export default __webpack_public_path__ + "static/media/cases.ed2738ad.jpg";